export default __webpack_public_path__ + "static/media/Custoditus.5c425276.jpg";